import React from "react";
import { STATUS_MAP, STATUS_BADGE } from "@/lib/statuses";

const StatusPill = ({ status, className = "" }) => {
  const s = STATUS_MAP[status];
  if (!s) return null;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] uppercase tracking-[0.15em] font-bold border ${STATUS_BADGE[status]} ${className}`}
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {s.short}
    </span>
  );
};

export default StatusPill;
